// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"Footer--next-sr-only--2Tgu-qr","footer":"Footer--footer--35vrryE","logo":"Footer--logo--17sH32g","copyright":"Footer--copyright--1b06PVM"};